module.exports = __webpack_public_path__ + "img/box5-06.da0dd57d.png";